import UserDataTable from "../../../../../components/user-data-table";

export default function FreeMember() {
  return (
    <>
      <div className="app-content pt-3 p-md-3 p-lg-4">
        <UserDataTable api="getDeletedMembers" title="Deleted Members" />
      </div>
    </>
  );
}
